import React from "react";
import { type BalanceTableProps } from "utils/types/wallet.type";
import BalanceRow from "./BalanceRow";

export default function BalanceTable({ wallets }: BalanceTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-200">
            <th className="py-3 px-4 text-left text-black-900 text-sm font-semibold border border-gray-300">
              Coin
            </th>
            <th className="py-3 px-4 text-left text-black-900 text-sm font-semibold border border-gray-300">
              Network
            </th>
            <th className="py-3 px-4 text-right text-black-900 text-sm font-semibold border border-gray-300">
              Balance
            </th>
            <th className="py-3 px-4 text-right text-black-900 text-sm font-semibold border border-gray-300">
              Balance (USD)
            </th>
          </tr>
        </thead>
        <tbody>
          {wallets.map((wallet, index) => (
            <BalanceRow key={index} wallet={wallet} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

